/**
 * OverlapValidatorDirective
 *
 * This directive is used to validate time entries for overlaps.
 * It checks if the current time entry overlaps with any other entries.
 */

import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[appOverlapValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: OverlapValidatorDirective, multi: true }],
})
export class OverlapValidatorDirective implements Validator {
    @Input('appOverlapValidator')
    set overlappingEntries(value: number[]) {
        this._overlappingEntries = value;
        if (this.onChange) {
            this.onChange();
        }
    }

    private _overlappingEntries: number[] = [];

    validate(control: AbstractControl): ValidationErrors | null {
        // If the field is empty, return null (no error)
        if (!control.value) {
            return null;
        }

        // Otherwise, check for overlaps
        if (this._overlappingEntries.length > 0) {
            return { overlap: `time-tracking.enterHoursCardComponent.overlap` };
        }
        return null;
    }

    registerOnValidatorChange(fn: () => void): void {
        this.onChange = fn;
    }

    private onChange: () => void = () => {};
}
